// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--g7MOX","seo-block":"_93444fe79c--seo-block--uwleI","title":"_93444fe79c--title--qfPTk","link":"_93444fe79c--link--TdeRx"};